import * as React from "react";

// BASE Components
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../../../../@BASE/core/NavLinkAdapter";
// Material UI
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Chip from "@mui/material/Chip";
import FavoriteIcon from "@mui/icons-material/Favorite";
import IconButton from "@mui/material/IconButton";
import ShareIcon from "@mui/icons-material/Share";
import Tooltip from "@mui/material/Tooltip";
import sx from "@mui/system/sx";

export default function SubComponentCard(props) {
  const { title, description, id, commentCount, children } = props;

  return (
    <Card className="square mt-24 mx-16 break-inside-avoid" elevation={0} variant="outlined">
      <CardHeader
        action={
          <>
            <Tooltip
              title={`${commentCount ? commentCount : 0} Comments`}
              placement="top"
            >
              <Chip
                icon={
                  <BASESvgIcon size={20} color="primary">
                    heroicons-outline:chat
                  </BASESvgIcon>
                }
                label={commentCount ? commentCount : 0}
                variant="outlined"
                className="mx-16"
                sx={{
                  backgroundColor: "common.white",
                  color: "primary.dark",
                }}
              />
            </Tooltip>
            <Tooltip title="Add Comment" placement="top">
              <Button
                variant="outlined"
                aria-label="Add Comment"
                component={NavLinkAdapter}
                to={`comments/new/edit?c=${id}&t=${title}`}
                size="small"
                sx={{
                  backgroundColor: "common.white",
                  color: "primary.dark",
                }}
              >
                <BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>
                <BASESvgIcon size={20}>heroicons-outline:chat</BASESvgIcon>
              </Button>
            </Tooltip>
          </>
        }
        title={title}
        titleTypographyProps={{ fontSize: 14, fontWeight: "bold" }}
        sx={{ backgroundColor: "#F1F5F9" }}
      />
      <CardContent className="p-0 border-t-1">{children}</CardContent>
    </Card>
  );
}
